import { AutoDirectorMessage } from '@/types/control';
import { AutoDirectorConfig } from '@/shared/types/GameStateModel';

import useWebSocket from './useWebsocket2';

const AUTO_DIRECTOR_NONCE = 1 as const;

export type AutoDirectorTuning = Pick<
  AutoDirectorConfig,
  'w_dist' | 'w_angle' | 'w_end' | 'hysteresis' | 'sustain' | 'hold'
>;

const useAutoDirector = () => {
  const socket = useWebSocket<AutoDirectorMessage>('/control/0.1.0');

  return {
    /**
     * Turning auto-director on optionally pushes the tuning it should run
     * with. The config follows the enable rather than preceding it so the
     * player is already in auto-director mode when it lands; both go out
     * back-to-back on the same socket.
     */
    enableAutoDirector: (config?: AutoDirectorTuning) => {
      socket.sendImmediately({ type: 'EnableAutoDirector', nonce: AUTO_DIRECTOR_NONCE });

      if (config) {
        socket.sendImmediately({
          type: 'SetAutoDirectorConfig',
          nonce: AUTO_DIRECTOR_NONCE,
          ...config,
        });
      }
    },
    disableAutoDirector: () => {
      socket.sendImmediately({ type: 'DisableAutoDirector', nonce: AUTO_DIRECTOR_NONCE });
    },
    setAutoDirectorConfig: (config: AutoDirectorTuning) => {
      socket.sendImmediately({
        type: 'SetAutoDirectorConfig',
        nonce: AUTO_DIRECTOR_NONCE,
        ...config,
      });
    },
  };
};

export default useAutoDirector;
